// @ts-nocheck

export const getAchievementIdFromProps = (_: unknown, { achievementId }: { achievementId?: number }) => achievementId;
export const getMissionIdFromProps = (_: unknown, { missionId }: { missionId?: number }) => missionId;
